import calendarInlineHideComponent from './calendarInlineHide.component';

let calendarInlineHideModule = angular.module('vacations-absences.calendarInlineHide', [])

.component('calendarInlineHide', calendarInlineHideComponent)

.name;

export default calendarInlineHideModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarInlineComponent/calendarInlineHide/calendarInlineHide.js